import React, { useRef } from "react";
import useAuthStore from "../../../../store/useAuthStore";

function CompanyLogo({ setProfileImage, setPreviewImage, previewImage }) {
  const fileInputRef = useRef(null);
  const { user } = useAuthStore();

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Create a new File object with the user's ID as the filename
      const renamedFile = new File([file], `${user.id}`, {
        type: file.type,
        lastModified: file.lastModified,
      });

      setProfileImage(renamedFile);

      // Create a preview URL for the image
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  return (
    <>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleImageChange}
        accept="image/*"
        style={{ display: "none" }}
      />
      <div className="flex flex-col relative">
        <div
          className={`relative w-[225px] h-[225px] bg-gray-100 rounded-md border border-gray-300 cursor-pointer`}
          onClick={handleImageClick}
        >
          {previewImage ? (
            <div className="mt-3 w-full h-full bg-gray-100 rounded-md overflow-hidden">
              <img
                src={previewImage}
                alt="Company Logo Preview"
                className="w-full h-full object-contain"
              />
            </div>
          ) : (
            <></>
          )}
          <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity">
            <span className="text-white font-medium">Change Photo</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default CompanyLogo;
